import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/Dashboard/actions.js";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Menu } from "antd";

const PIPELINE_IN_PROGRESS_STATUSES = [
  "Pending",
  "Processing",
  "In Progress",
  "Progress",
  "Custom Topics Running",
  "Deleting Custom Topic",
];

export const isDashboardPipelineIncomplete = (status) =>
  !status || PIPELINE_IN_PROGRESS_STATUSES.includes(status);

const NestedTabs = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const { id } = useParams();
  const DashboardReducer = useSelector((state) => state.DashboardReducer);
  const currentDashboard = DashboardReducer.dashboard?.ID || id;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const savedSearchAvailable = DashboardReducer.status?.saved_search_available;
  const dashboardStatus = DashboardReducer.dashboard?.Status;
  const showProgressTab = isDashboardPipelineIncomplete(dashboardStatus);
  const DashboardKeys = [
    "DashboardData",
    "Dashboard",
    "journey",
    "insights",
    "geolocation",
    "savedSearches",
    "combined-view",
    "topic-gap",
  ];

  useEffect(() => {
    if (window.innerWidth < 1100) {
      setIsMobileView(true);
    }
    function handleResize() {
      if (window.innerWidth < 1100) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    let defaultSelected = document.location.pathname.split("/")[2];
    history.listen(() => {
      defaultSelected = document.location.pathname.split("/")[2];
      setSelectedMenuItem(defaultSelected);
    });
    setSelectedMenuItem(defaultSelected);
    window.addEventListener("resize", handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!currentDashboard) return;
    const activeTab = location.pathname.split("/")[2];
    // Custom Topics tab is always available (empty state + Topic Library run).
    // Only redirect away from Saved Searches when none exist.
    if (activeTab === "savedSearches" && savedSearchAvailable === false) {
      history.replace({
        pathname: `/console/DashboardData/${currentDashboard}`,
        search: location.search,
      });
    }
    if (
      activeTab === "journey" &&
      dashboardStatus &&
      !PIPELINE_IN_PROGRESS_STATUSES.includes(dashboardStatus)
    ) {
      history.replace({
        pathname: `/console/DashboardData/${currentDashboard}`,
        search: location.search,
      });
    }
  }, [
    currentDashboard,
    savedSearchAvailable,
    dashboardStatus,
    history,
    location.pathname,
    location.search,
  ]);

  const handleClick = (e) => {
    if (e.key === "DashboardData" || e.key === "savedSearches") {
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: false,
        },
      });
    }
    for (let l = 1; l >= 1; l++) {
      if (params.has(`level${l}Selection`)) {
        params.delete(`level${l}Selection`);
        history.push({ search: params.toString() });
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            [`selectedL${l}Topic`]: null,
          },
        });
      } else {
        break;
      }
    }
    [
      "sentiment",
      "intent",
      "rating",
      "top_topics",
      "topics_operator",
      "platform_id",
      "match_date",
      "hotterm",
      "nps",
      "keyword",
      "pivotFilter",
      "pivots_operator",
      "view_type",
      "topics_type",
      "selected_topic",
      "insightTopicSearch",
      "insightTopicClosed",
      "start_index",
      "page_offset",
      "decisionFilter",
      "cursor_next",
      "cursor_curr",
      "cursor_before",
      "savedSearchID",
      "child_others",
      "parent_others",
    ].forEach((item) => params.delete(item));
    setSelectedMenuItem(e.key);
    if (currentDashboard && DashboardKeys.includes(e.key)) {
      history.push({
        pathname: `/console/${e.key}/${currentDashboard}`,
        search: params.toString(),
      });
    } else {
      history.push({
        pathname: `/console/${e.key}`,
        search: params.toString(),
      });
    }
  };

  return (
    <div className={styles.nestedTabContainer}>
      {currentDashboard &&
        DashboardKeys.includes(document.location.pathname.split("/")[2]) && (
          <Menu
            onClick={handleClick}
            selectedKeys={[selectedMenuItem]}
            defaultOpenKeys={[isMobileView ? "" : "DashboardGroup"]}
            mode="horizontal"
            className={styles.nestedMenuItem}
          >
            <Menu.Item key="DashboardData">
              <Link to={`/console/DashboardData/${currentDashboard}`}>
                {t("selected_dashboard_sidebar.1")}
              </Link>
            </Menu.Item>
            {/* <Menu.Item key="Dashboard">
              <Link to={`/console/Dashboard/${currentDashboard}`}>
                {t("selected_dashboard_sidebar.2")}
              </Link>
            </Menu.Item> */}
            <Menu.Item key="combined-view">
              <Link to={`/console/combined-view/${currentDashboard}`}>
                {t("dashboard.combined_view")}
              </Link>
            </Menu.Item>
            <Menu.Item key="topic-gap">
              <Link to={`/console/topic-gap/${currentDashboard}`}>
                {t("dashboard.topic_gap_title", {
                  defaultValue: "Keşfedilen konseptler",
                })}
              </Link>
            </Menu.Item>
            {showProgressTab && (
              <Menu.Item key="journey">
                <Link to={`/console/journey/${currentDashboard}`}>
                  {t("selected_dashboard_sidebar.5")}
                </Link>
              </Menu.Item>
            )}
            {savedSearchAvailable === true && (
              <Menu.Item key="savedSearches">
                <Link to={`/console/savedSearches/${currentDashboard}`}>
                  {t("selected_dashboard_sidebar.8")}
                </Link>
              </Menu.Item>
            )}
          </Menu>
        )}
    </div>
  );
};

export default NestedTabs;
